import { Layout } from "antd";
import { Outlet } from "react-router-dom";
import { BreadCrumbs } from "~pages/Shared/Root/components/BreadCrumbs/BreadCrumbs";
import { Footer } from "~pages/Shared/Root/components/Footer/Footer";
import { Header } from "~pages/Shared/Root/components/Header/Header";
import { Sidedrawer } from "~pages/Shared/Root/components/Sidedrawer/Sidedrawer";

export const Root = () => {
  return (
    <Layout>
      <Sidedrawer />
      <Layout
        style={{
          marginLeft: 65,
        }}
      >
        <Header />
        <Layout.Content style={{ padding: "20px 25px", paddingBottom: "100px" }}>
          <BreadCrumbs />
          <Outlet />
        </Layout.Content>
        <Footer />
      </Layout>
    </Layout>
  );
};
